import React, { useState } from 'react';
import {
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    Typography,
    Pagination
} from '@mui/material';
import { Translate } from '../../../../shared/LanguageService';

export type Firm = {
    id: number;
    name: string;
};

const FIRMS_PER_PAGE = 10;

const FirmFormComponentBlocked: React.FC<{ blockedForFirms: Firm[] }> = ({ blockedForFirms }) => {
    const [searchString, setSearchString] = useState<string>('');
    const [activePage, setActivePage] = useState<number>(1);

    const filteredFirms = blockedForFirms.filter((firm) =>
        firm.name.toLowerCase().includes(searchString.toLowerCase())
    );

    const numberOfPages = Math.ceil(filteredFirms.length / FIRMS_PER_PAGE);
    const firmsOnPageStartIndex = (activePage - 1) * FIRMS_PER_PAGE;
    const paginatedFirms = filteredFirms.slice(
        firmsOnPageStartIndex,
        firmsOnPageStartIndex + FIRMS_PER_PAGE
    );

    const handlePageSelect = (_: React.ChangeEvent<unknown>, page: number) => {
        setActivePage(page);
    };

    const updateSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchString(event.target.value);
        if (activePage > numberOfPages) {
            setActivePage(1);
        }
    };

    return (
        <fieldset>
            <legend>{Translate('photographers/modal/tab/blocked-for-firms')}</legend>
            <TextField
                label={Translate('photographers/modal/blocked-for-firms-tab/search-firms')}
                variant="outlined"
                size="small"
                fullWidth
                value={searchString}
                onChange={updateSearch}
                sx={{ marginBottom: '16px' }}
            />

            {filteredFirms.length > 0 ? (
                <>
                    <TableContainer>
                        <Table>
                            <TableBody>
                                {paginatedFirms.map((firm) => (
                                    <TableRow key={firm.id}>
                                        <TableCell>{firm.name}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {numberOfPages > 1 && (
                        <Pagination
                            count={numberOfPages}
                            page={activePage}
                            onChange={handlePageSelect}
                            color="primary"
                            sx={{ marginTop: 2 }}
                        />
                    )}
                </>
            ) : (
                <Typography variant="body2">
                    {Translate('photographers/modal/blocked-for-firms-tab/no-firms-found')}
                </Typography>
            )}
        </fieldset>
    );
};

export default FirmFormComponentBlocked;
